<template>
  <div class="basic-info">
    <ul-form
      ref="basicInfo"
      :model="infoForm"
      :rules="rules"
      label-width="80px"
    >
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_648')"
        prop="name"
      >
        <ul-input
          v-model="infoForm.name"
          :placeholder="$t('pages_experimentView_basicInfo_649')"
        ></ul-input>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_650')"
        prop="introduce"
        :required="true"
        v-if="virtual.type == 1"
      >
        <Editor
          v-model="infoForm.introduce"
          @onChange="changeText"
          :height="220"
          :placeholder="$t('pages_experimentView_basicInfo_651')"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item :label="$t('pages_experimentView_basicInfo_652')">
        <label class="uploading" for="avatar">{{
          $t("pages_experimentView_basicInfo_671")
        }}</label>
        <input
          v-show="false"
          type="file"
          id="avatar"
          style="position: absolute; clip: rect(0 0 0 0)"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg($event)"
        />
        <span class="hint">{{ $t("pages_experimentView_basicInfo_672") }}</span>
        <img class="cover" :src="infoForm.cover || homePage" />
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_653')"
        prop="studytime"
      >
        <ul-input
          class="score-input"
          v-model="infoForm.studytime"
          :placeholder="$t('pages_experimentView_basicInfo_654')"
          type="number"
        />
        <span class="hint">{{ $t("pages_experimentView_basicInfo_673") }}</span>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_655')"
        prop="academic"
        v-if="virtual.type == 2"
      >
        <ul-input
          class="text-input"
          v-model="infoForm.academic"
          :placeholder="$t('pages_experimentView_basicInfo_656')"
        ></ul-input>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_657')"
        prop="teacher"
        v-if="virtual.type == 1"
      >
        <ul-input
          class="text-input"
          v-model="infoForm.teacher"
          :placeholder="$t('pages_experimentView_basicInfo_658')"
        ></ul-input>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_659')"
        prop="school"
        v-if="virtual.type == 1"
      >
        <ul-autocomplete
          class="text-input"
          v-model="infoForm.school"
          :fetch-suggestions="querySearch"
          :value-key="'orgName'"
          :placeholder="$t('pages_experimentView_basicInfo_660')"
          :trigger-on-focus="false"
          @select="handleSelect"
        ></ul-autocomplete>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_661')"
        prop="speciality"
        v-if="virtual.type == 1"
      >
        <ul-input
          class="text-input"
          v-model="infoForm.speciality"
          :placeholder="$t('pages_experimentView_basicInfo_662')"
        ></ul-input>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_663')"
        prop="introduce"
        :required="true"
        v-if="virtual.type == 2"
      >
        <Editor
          v-model="infoForm.introduce"
          @onChange="changeText"
          :height="220"
          :placeholder="$t('pages_experimentView_basicInfo_664')"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_665')"
        prop="teachTarget"
        v-if="virtual.type == 2"
      >
        <Editor
          v-model="infoForm.teachTarget"
          @onChange="changeTargetText"
          :height="220"
          :placeholder="$t('pages_experimentView_basicInfo_666')"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_667')"
        prop="teachContent"
        v-if="virtual.type == 2"
      >
        <Editor
          v-model="infoForm.teachContent"
          @onChange="changeContentText"
          :height="220"
          :placeholder="$t('pages_experimentView_basicInfo_668')"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item
        :label="$t('pages_experimentView_basicInfo_669')"
        prop="effect"
        v-if="virtual.type == 2"
      >
        <Editor
          v-model="infoForm.effect"
          @onChange="changeEffectText"
          :height="220"
          :placeholder="$t('pages_experimentView_basicInfo_670')"
        >
        </Editor>
      </ul-form-item>
    </ul-form>
    <div class="line"></div>
    <ul-button type="primary" @click="save">{{
      $t("pages_experimentView_basicInfo_674")
    }}</ul-button>

    <cropper ref="cropperDialog" @upData="upDataPicurl"></cropper>
  </div>
</template>

<script>
import Editor from "pc/components/editor.vue";
import cropper from "./components/cropper.vue";
import homePage from "@/assets/images/virtual/homePage.png";
import { saveCourseInfo, getCourseInfo } from "@/api/courseApi/virtual.js";
import { getAllOrgan } from "@/api/courseApi/index.js";
import { wordCount } from "@/utils/index";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Editor,
    cropper,
  },
  computed: {
    ...mapGetters("virtual", { virtual: "virtual" }),
    courseId() {
      return this.$route.params.id;
    },
    rules() {
      var validateRequest = (rule, value, callback) => {
        console.log(wordCount(value));
        if (wordCount(value) < 1) {
          callback(new Error(this.$t("pages_experimentView_basicInfo_675")));
        } else if (wordCount(value) > 10000) {
          callback(new Error(this.$t("pages_experimentView_basicInfo_676")));
        } else {
          callback();
        }
      };
      let rules = {
        name: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_677"),
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$t("pages_experimentView_basicInfo_678"),
            trigger: "blur",
          },
        ],
        introduce: [{ validator: validateRequest, trigger: "change" }],
        cover: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_679"),
            trigger: "blur",
          },
        ],
        studytime: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_680"),
            trigger: "blur",
          },
          {
            pattern: /^[1-9]\d*$/,
            message: this.$t("pages_experimentView_basicInfo_681"),
            trigger: "blur",
          },
        ],
        teacher: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_682"),
            trigger: "blur",
          },
        ],
        academic: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_683"),
            trigger: "blur",
          },
        ],
        school: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_684"),
            trigger: "blur",
          },
        ],
        speciality: [
          {
            required: true,
            message: this.$t("pages_experimentView_basicInfo_685"),
            trigger: "blur",
          },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      homePage,
      infoForm: {
        id: this.$route.params.id,
        name: "",
        introduce: "",
        cover: "",
        studytime: "",
        teacher: "",
        school: "",
        speciality: "",
      },
      restaurants: [],
    };
  },
  created() {
    window.test = this;
    getAllOrgan().then((res) => {
      this.restaurants = res;
    });
  },
  mounted() {
    console.log("-------" + this.virtual.name);
    this.infoForm = JSON.parse(JSON.stringify(this.virtual));
  },
  methods: {
    ...mapActions("virtual", ["setVirtual"]),
    courseInfo() {
      getCourseInfo({ courseId: this.courseId }).then(({ result }) => {
        this.setVirtual(result);
      });
    },
    save() {
      this.$refs.basicInfo.validate((valid) => {
        if (valid) {
          saveCourseInfo(this.infoForm).then((res) => {
            this.courseInfo();
            this.$message({
              message: this.$t("pages_experimentView_basicInfo_686"),
              type: "success",
            });
          });
        }
      });
    },
    changeText(text) {
      this.infoForm.introduce = text;
    },
    changeTargetText(text) {
      this.infoForm.teachTarget = text;
    },
    changeContentText(text) {
      this.infoForm.teachContent = text;
    },
    changeEffectText(text) {
      this.infoForm.effect = text;
    },
    uploadImg(e) {
      let data = {
        title: this.$t("pages_experimentView_basicInfo_687"),
      };
      this.$refs.cropperDialog.uploadImg(e, data);
    },
    upDataPicurl(url) {
      this.$set(this.infoForm, "cover", url);
    },
    handleSelect(item) {
      console.log(item);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.orgName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-info {
  padding-top: 32px;
  .line {
    border-top: 1px dashed #e3e3e9;
    margin: 20px 0;
  }
  .score-input {
    width: 110px;
    margin-right: 10px;
  }
  .hint {
    color: #969696;
  }
  .uploading {
    color: #8d77fb;
    cursor: pointer;
    margin-right: 12px;
  }
  .cover {
    display: block;
    width: 208px;
  }
  .text-input {
    width: 380px;
  }
}
</style>